import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="px-6 md:px-10 lg:px-20 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="w-full lg:w-1/2">
            <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300 text-primary-700 text-sm font-medium mb-6">
              Hipobuy Sheet 101
            </span>
            <img
              src="https://readdy.ai/api/search-image?query=Beautifully%20styled%20creative%20workspace%20with%20open%20leather%20bound%20journal%20showing%20handwritten%20product%20research%20notes%20and%20colorful%20sticky%20tab%20markers%2C%20ceramic%20coffee%20cup%20with%20latte%20art%20on%20warm%20oak%20desk%2C%20small%20potted%20snake%20plant%2C%20morning%20sunlight%20streaming%20through%20sheer%20linen%20curtains%2C%20soft%20beige%20and%20warm%20wood%20tones%2C%20organized%20creative%20chaos%2C%20editorial%20photography%2C%20modern%20bohemian%20studio%20aesthetic%2C%20no%20text%20visible%2C%20inspiring%20productive%20atmosphere&width=1000&height=750&seq=about-v2-workspace-scene&orientation=landscape"
              alt="What is Hipobuy Spreadsheet - comprehensive shopping resource guide"
              title="Hipobuy Spreadsheet Guide"
              className="w-full h-auto rounded-2xl object-cover"
              style={{ maxHeight: '480px' }}
            />
          </div>

          <div className="w-full lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-6">
              The Ultimate Resource Hub
              <br />
              For Smart Shopping
            </h2>
            <p className="text-foreground-500 text-base leading-relaxed mb-5">
              Hipobuy Spreadsheet is a structured resource system that helps shoppers organize, compare and discover products efficiently. Instead of spending hours searching across multiple platforms, users can access categorized product information, buying guides and comparison resources in one convenient place.
            </p>

            <div className="overflow-hidden rounded-xl border border-background-200/70 mb-8">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-200/40">
                    <th className="text-left px-5 py-3 text-foreground-700 font-semibold">Feature</th>
                    <th className="text-left px-5 py-3 text-foreground-400 font-medium">Traditional Search</th>
                    <th className="text-left px-5 py-3 text-primary-700 font-semibold">Hipobuy Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ['Product Discovery', 'Slow', 'Organized'],
                    ['Comparison', 'Manual', 'Structured'],
                    ['Research Time', 'Hours', 'Minutes'],
                    ['Beginner Friendly', 'Low', 'High'],
                    ['Category Filtering', 'Limited', 'Advanced'],
                  ].map((row) => (
                    <tr key={row[0]} className="border-t border-background-200/50">
                      <td className="px-5 py-3 text-foreground-700 font-medium">{row[0]}</td>
                      <td className="px-5 py-3 text-foreground-400">{row[1]}</td>
                      <td className="px-5 py-3 text-primary-700 font-medium">{row[2]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Link
              to="/what-is-hipobuy-sheet"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-foreground-900 text-white text-sm font-semibold hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
            >
              Read Complete SEO Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;